<template>
  <div class="order_items_container" v-infinite-scroll="loadMore" infinite-scroll-disabled='loading' infinite-scroll-distance='10'>
    <div class="item_card" v-for='(item, index) in orderData' :key="index">
      <div class="item_header">
        <span class="site_name">{{ item.site_name }}</span>
        <span class="order_status_badge">订单完成</span>
      </div>
      <div class="item_body">
        <div class="item_type_row">
          <span class="type_label">{{ item.order_type === 3 ? '中石油' : '撬装点' }}</span>
          <span class="time_val">{{ item.create_time }}</span>
        </div>
        <div class="item_data_grid">
          <div class="data_item">
            <span class="data_label">加油量</span>
            <span class="data_val highlight">{{ item.num }}<small> 升</small></span>
          </div>
          <div class="data_item" v-if="item.order_type === 3">
            <span class="data_label">总价</span>
            <span class="data_val">￥{{ item.total_money }}</span>
          </div>
          <div class="data_item">
            <span class="data_label">车牌号</span>
            <span class="data_val">{{ item.car_number }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!--显示加载中-->
    <div class="loading-box" v-if="isloading">
      <mt-spinner type="snake"></mt-spinner>
      <span class="loading-more-txt">加载中...</span>
    </div>
    <!-- 显示没有更多 -->
    <div class="no-more" v-show="noMone">已经到底啦</div>
  </div>
</template>

<script>
import common from "../common";
import {InfiniteScroll, Spinner} from 'mint-ui';
import Vue from "vue";

Vue.use(InfiniteScroll);
Vue.component(Spinner.name, Spinner);
export default {
  name: 'lineItem',
  data() {
    return {
      msg: '订单详情',
      orderData: [],
      pageVal: "0",
      pageSize: "10",
      loading: false, //为true时不会触发加载更多，false可以触发
      isloading: false,//显示加载中
      noMone: false,//是否没有更多
      token: ""
    }
  },
  methods: {
    //获取列表
    getList() {
      let token = this.token;
      let querystring = require('querystring');
      this.$api.post('wx/orderList',
          querystring.stringify({
            pageSize: this.pageSize,
            pageNum: this.pageVal,
            token: token
          })
      ).then(data => {
        if (this.pageVal < data.data.pageTotal) {
          for (var i = 0; i < this.pageSize; i++) {
            this.orderData.push(data.data.data[i]);
          }
          this.loading = false;
        } else if (this.pageVal == data.data.pageTotal) {
          for (var i = 0; i < data.data.data.length; i++) {
            this.orderData.push(data.data.data[i]);
          }
          this.loading = false;
        } else {
          this.loading = true;
          this.noMone = true;
        }
        this.isloading = false;
      }).catch(err => {
        console.log(err);
      })
    },
    //分页加载更多
    loadMore() {
      this.loading = true;
      this.isloading = true;
      this.pageVal++;
      this.getList();
    },
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
    } else {
      this.$router.replace({name: 'login'});
    }
  },
  beforeDestroy() {

  },
}
</script>

<style scoped>
.order_items_container {
  width: 100vw;
  height: 100vh;
  background: #f6f8fa;
  overflow-y: auto;
  padding: 16px;
  box-sizing: border-box;
}

.item_card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.item_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f3f5;
}

.site_name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.order_status_badge {
  background: #f0fdf4;
  color: #16a34a;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
}

.item_body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.item_type_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.type_label {
  font-size: 13px;
  background: #f8f9fa;
  color: #495057;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.time_val {
  font-size: 12px;
  color: #adb5bd;
}

.item_data_grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 16px;
  padding-top: 4px;
}

.data_item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.data_label {
  font-size: 11px;
  color: #adb5bd;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data_val {
  font-size: 14px;
  color: #495057;
  font-weight: 700;
}

.data_val.highlight {
  color: #106EBE;
  font-size: 18px;
}

.data_val small {
  font-size: 12px;
  font-weight: 500;
}

.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  color: #adb5bd;
  font-size: 14px;
  gap: 10px;
}

.no-more {
  text-align: center;
  color: #adb5bd;
  font-size: 14px;
  padding: 40px 0;
}
</style>
      


// WEBPACK FOOTER //
// src/components/lineItem.vue